<script>
import Layout from '@layouts/main'

import {AxiosHelper} from '@src/utils/utils';
import Grid from '@components/Grid';
import { Base64 } from 'js-base64';

export default {
	components: { Layout, Grid },
  data() {
    return {
			gridData1 : [],
			gridData2 : [],
			alertOption1 : '',
			showAlert : false,
			loading : false,
			tableOption1 : {
				scrollY:350,
				columns : [
					{ data:'idx' },
					{ data:'cate_name' },
					{ data:'color' },
				],
			},
			editOption1 : {
				sourceStore : {},
				columnDefs : [
					{
						targets : 0,
						type : 'number',
					},
					{
						targets : 1,
						type : 'text',
					},
					{
						targets : 2,
						type : 'text',
					},
				]
			},

			tableOption2 : {
				scrollY:350,
				columns : [
					{ data:'group1' },
					{ data:'group2' },
				],
			},

			editOption2 : {
				sourceStore : {},
				columnDefs : [
					{
						targets : 0,
						type : 'text',
					},
					{
						targets : 1,
						type : 'text',
					},
				]
			},

    }
	},
	mounted() {
		AxiosHelper.get('/api/cardsms/group/kind').then(ret => {
			this.gridData1 = ret.data;
		});

		AxiosHelper.get('/api/cardsms/group/category').then(ret => {
			this.gridData2 = ret.data;
		});
	},
	methods : {
		addBtn1Click : function() {
			this.gridData1 = this.gridData1.concat([{idx : 0, cate_name : '',  color : ''}])	
		},

		saveList1Click : function() {
			var s = encodeURIComponent(JSON.stringify(this.gridData1));
			var encodeData = Base64.encode(s);

			AxiosHelper.post('/api/cardsms/group/kind/update', {
				encodeData : encodeData
			}).then(ret => {
				this.pushMessage('저장완료');
			});
		},

		addBtn2Click : function() {
			this.gridData2 = this.gridData2.concat([{group1 : '&#8203;',  group2 : '&#8203;'}])
		},

		saveList2Click : function() {
			var s = encodeURIComponent(JSON.stringify(this.gridData2));
			var encodeData = Base64.encode(s);

			AxiosHelper.post('/api/cardsms/group/category/update', {
				encodeData : encodeData
			}).then(ret => {
				this.pushMessage('저장완료');
			});
		},


	}
}
</script>

<template>
  <Layout>
    <C.PageHeader title="생활비 그룹관리" />
    <C.Row>
			<C.Col lg="6">
				<C.Card>
					<C.CardHeader>지출분류</C.CardHeader>
					<C.CardBody>
						<C.FormGroup class="button-list mt-2 mb-1">
							<button type="button" class="btn btn-blue"
								@click="addBtn1Click">추가</button>
							<button type="button" class="btn btn-success" 
								@click="saveList1Click">저장</button>
						</C.FormGroup>

						<Grid :data="gridData1" :option="tableOption1" :edit-option="editOption1">
							<tr slot="thead">
								<th>인덱스</th>
								<th>지출분류</th>
								<th>색상</th>
							</tr>
						</Grid>
					</C.CardBody>
				</C.Card>
        <!-- end card-box -->
			</C.Col>
			
			<C.Col lg="6">
				<C.Card>
					<C.CardHeader>생활비 상세분류</C.CardHeader>
					<C.CardBody>
						<C.FormGroup class="button-list mt-2 mb-1">
							<button type="button" class="btn btn-blue"
								@click="addBtn2Click">추가</button>
							<button type="button" class="btn btn-success"
								@click="saveList2Click">저장</button>
						</C.FormGroup>

						<Grid :data="gridData2" :option="tableOption2" :edit-option="editOption2">
							<tr slot="thead">
								<th>중분류</th>
								<th>소분류</th>
							</tr>
						</Grid>
					</C.CardBody>
				</C.Card>
        <!-- end card-box -->
			</C.Col>

    </C.Row>
    <!--- end row -->

  </Layout>
</template>